let origin = "https://future.zhuneng.cn";
//公交信息
const busStopUrl = `/gateway/hc-external/busInfo/getBusLineInfo`;
//天气
const getWeatherUrl = `/gateway/hc-external/amap/getWeather`;
export { busStopUrl, getWeatherUrl };
